var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1629 3.63477H14.8672C16.2413 3.63477 17.3643 4.71031 17.4401 6.0655L17.4442 6.21173V13.7444C17.4442 15.1185 16.3686 16.2414 15.0134 16.3173L14.8672 16.3214H4.1629C2.78876 16.3214 1.66582 15.2458 1.59001 13.8906L1.58594 13.7444V6.21173C1.58594 4.83759 2.66148 3.71465 4.01667 3.63884L4.1629 3.63477H14.8672H4.1629ZM16.2548 7.89509L9.79203 11.2972C9.64344 11.3754 9.46995 11.3866 9.3143 11.3308L9.2381 11.2972L2.77531 7.89588V13.7444C2.77531 14.4725 3.33598 15.0695 4.0491 15.1274L4.1629 15.132H14.8672C15.5953 15.132 16.1923 14.5713 16.2502 13.8582L16.2548 13.7444V7.89509ZM14.8672 4.82413H4.1629C3.43488 4.82413 2.8378 5.38481 2.77991 6.09792L2.77531 6.21173V6.55189L9.51506 10.099L16.2548 6.5511V6.21173C16.2548 5.4837 15.6942 4.88662 14.981 4.82873L14.8672 4.82413Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d14b57ab0f466081cf2d686d6c27e36d.svg";
export { ForwardRef as ReactComponent };